import { Model } from '../Types';
import { StoreSettings } from '../Types/StoreTypes';
import requestClient from '../components/Utility/RequestClient';

export const settingsService = {
    getSettings: async (demo: any): Promise<any> => {
        return requestClient.get<StoreSettings>(`${demo ? '/demo' : ''}/settings/get`);
    },

    getModels: async (): Promise<{ data: Model[] }> => {
        return requestClient.get<Model[]>('/settings/allmodels');
    },

    saveSettings: async (data: any): Promise<any> => {
        return requestClient.post<StoreSettings>(`/settings/update`, data);
    },

    updateVersion: async (version: string): Promise<any> => {
        return requestClient.post<StoreSettings>(`/settings/updateversion`, { version });
    },

    getAllMimeTypes: async (): Promise<{ data: string[] }> => {
        return requestClient.get<string[]>(`/settings/allmimetypes`);
    },

    getAllMimeTypesAndFileExtensions: async (
        model?: string | null,
        documentProcessingMode?: string | null,
    ): Promise<{ data: { [key: string]: string[] } }> => {
        const params = new URLSearchParams();
        if (model) params.set('model', model);
        if (documentProcessingMode) params.set('documentProcessingMode', documentProcessingMode);
        const query = params.toString();
        return requestClient.get<{ [key: string]: string[] }>(
            `/settings/allmimetypesandfileextensions${query ? `?${query}` : ''}`,
        );
    },

    acceptDsgvo: async (): Promise<any> => {
        return requestClient.post<void>(`/settings/acceptdsgvo`);
    },
};
